<template>
    <div v-if="layoutVersion === 'v1'" class="cielo-layout cielo-layout--v1">
        <CieloHeader />
        <div class="cielo-layout__container">
            <section class="cielo-layout__section cielo-layout__section--slot" ref="startingPoint">
                <slot />
            </section>
        </div>
    </div>

    <div v-else-if="layoutVersion === 'v2'" class="cielo-layout cielo-layout--v2">
        <CieloHeader />

        <div class="cielo-layout__container">
            <section class="cielo-layout__section cielo-layout__section--link-info">
                <LinkInfo
                    :is-mobile="renderMobile()"
                    :show-merchant-name="showMerchantName"
                />
                <CieloFooter v-if="!renderMobile()" />
            </section>          
            <section class="cielo-layout__section cielo-layout__section--slot" ref="startingPoint">
                <BreadCrumb v-if="isDofEnabled" />
                <slot />
            </section>
            <CieloFooter v-if="renderMobile()" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CieloHeader from '@/components/template/CieloHeader';
import CieloFooter from '@/components/template/CieloFooter';
import BreadCrumb from '@/components/BreadCrumb';
import LinkInfo from '@/components/LinkInfo';
import { isMobile } from '@/helpers/isMobile';
import { logException } from '@/helpers/cieloLogger';

export default {
  components: {
    CieloHeader,
    CieloFooter,
    LinkInfo,
    BreadCrumb,
  },

  computed: {
    ...mapGetters({
      isDofEnabled: 'dataOnFile/isDofEnabled',
    }),
  },

  methods: {
    renderMobile() {
      return isMobile('1024');
    },
    applyStartPoint() {
        try {
          setTimeout(() => {
              let element = this.$refs.startingPoint;
              if(!element) return;
              let firstChild = element.querySelector(':first-child').querySelector(':first-child');
			        if(!firstChild) return;
              firstChild.classList.add('starting-point');
              firstChild.focus();
          }, 1000);
        } catch (error) {
            logException(error);
        }
    }
  },

  props: {
    showMerchantName: {
      type: Boolean,
      default: true
    },
    layoutVersion: {
      type: String,
      default: 'v2'
    },
    startingPointBySlot: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
      if(this.startingPointBySlot) this.applyStartPoint();
  }
};
</script>

<style lang="scss" scoped>
.cielo-layout{
    display: flex;
    flex-direction: column;
    min-height: 100%;

    @media screen and (min-width: 1025px) {
      justify-content: center;
    }

  &--v1 {
      .cielo-header {
          border-bottom: 1px solid #B8C1CC;
      }

      .cielo-layout {
          &__container {
              display: flex;
              flex-direction: column;
              justify-content: center;
              flex: 1 0 auto;
              width: 100%;

              @media screen and (min-width: 1025px) {
                max-width: 1180px;
                margin: 0 auto;
                padding: 48px 16px;
                flex-direction: row;
              }

              @media screen and (min-width: 1165px) {
                padding: 48px 0;
              }
          }

          &__section--slot {
              display: flex;
              flex-direction: column;
              flex: 1 0 auto;
              width: 100%;
              padding: 24px 16px;

              @media screen and (min-width: 1025px) {
                  padding: 0;
              }
          }
      }
  }

  &--v2 {
      .cielo-layout {
          &__container {
              display: flex;
              flex-direction: column;
              align-self: center;
              flex: 1 0 auto;
              width: 100%;

              @media screen and (min-width: 1025px) {
                max-width: 1180px;
                margin: 0 auto;
                padding: 48px 16px;
                flex-direction: row;
              }

              @media screen and (min-width: 1165px) {
                padding: 48px 0;
              }
          }

          &__section {}

          &__section--link-info {
              @media screen and (min-width: 1025px) {
                  order: 2;
                  margin-left: 60px;
                  width: calc(45% - 60px);
              }
          }

          &__section--slot {
              padding: 24px 16px;

              @media screen and (max-width: 1024px) {
                  display: flex;
                  flex-direction: column;
                  flex: 1 0 auto;
              }


              @media screen and (min-width: 1025px) {
                  padding: 0;
                  margin-right: 60px;
                  width: calc(55% - 60px);
              }
          }
      }
  }

}
</style>
